import qs from 'qs';

export const cleanPath = (path: string | number): string => `${path}`.replace(/^\/+|\/+$/g, '');

type PathParams = Record<string, string | number>;

export const applyPathParams = (base: string, params: PathParams = {}) => {
	const copied = { ...params };

	Object.entries(params).forEach(([key, value]) => {
		if (base.includes(`:${key}`)) {
			base = base.replaceAll(`:${key}`, `${value}`);
			delete copied[key];
		}
	});

	if (Object.keys(copied).length) {
		const searchParams = qs.stringify(copied);
		base = `${base}?${searchParams}`;
	}

	return base;
};

export const joinPath = (...paths: (string | number)[]): string => paths.map(cleanPath).join('/');

export const buildURL =
	(base = '') =>
	(...paths: (string | number)[]): string =>
		joinPath(base, ...paths);
